<template>
  <div class="vx-col w-full mb-base m-auto">
    <vx-card>
      <div class="vx-card__title">
        <h4 class>{{ planID ? 'Edit' : 'Add' }} Subcription Plan</h4>
      </div>
      <form autocomplete="off">
        <div class="vx-row mb-2">
          <div class="vx-col md:w-1/2 form-group w-full">
            <vs-input
              class="w-full"
              label="Name"
              v-validate="'required|alphaNumSpace|max:30'"
              name="plan_name"
              v-model="plan_name"
              autocomplete="off"
              id="title"
            />
            <span class="text-danger text-sm">{{ errors.first('plan_name') }}</span>
          </div>
          <div class="vx-col md:w-1/2 form-group w-full">
            <vs-input
              type="number"
              @keydown="filterKey"
              class="w-full"
              label="No. Of Users Allowed"
              v-validate="'required|numeric|max:5'"
              name="no_of_users_allowed"
              v-model="no_of_users_allowed"
              autocomplete="off"
            />
            <span class="text-danger text-sm">{{ errors.first('no_of_users_allowed') }}</span>
          </div>
          <div class="vx-col md:w-1/3 form-group w-full" v-if="!is_freeplan">
            <vs-input
              class="w-full"
              label="Annual Price"
              v-validate="'required|decimal:2|max:9'"
              name="price_per_year"
              v-model="price_per_year"
              autocomplete="off"
              type="number"
              :disabled="planID"
            />
            <span class="text-danger text-sm">{{ errors.first('price_per_year') }}</span>
          </div>
          <div class="vx-col md:w-1/3 form-group w-full" v-if="!is_freeplan">
            <vs-input
              class="w-full"
              label="Quarterly Price"
              v-validate="{is_not: price_per_year,decimal:2,max_value:price_per_year,max:9}"
              name="price_per_quarter"
              v-model="price_per_quarter"
              autocomplete="off"
              type="number"
              :disabled="planID"
            />
            <span class="text-danger text-sm">{{ errors.first('price_per_quarter') }}</span>
          </div>
          <!-- <div class="vx-col md:w-1/3 form-group w-full" v-if="!is_freeplan">
            <vs-input
              class="w-full"
              label="Monthly Price"
              v-validate="'decimal:2|max:9'"
              name="price_per_month"
              v-model="price_per_month"
              autocomplete="off"
              type="number"
              :disabled="planID"
              
            />
            <span class="text-danger text-sm">{{ errors.first('price_per_month') }}</span>
          </div>-->
          <!-- <div class="vx-col md:w-1/4 form-group w-full">
            <vs-select
              autocomplete
              class="w-full"
              v-validate="'required'"
              label="Period"
              name="period"
              v-model="period"
            >
              <vs-select-item
                :key="index"
                :value="item.value"
                :text="item.text"
                v-for="(item,index) in periodList"
              />
            </vs-select>
            <span class="text-danger text-sm">{{ errors.first('period') }}</span>
          </div>-->
          <!-- <div class="vx-col md:w-1/4 form-group w-full">
            <vs-input
              class="w-full"
              label="No. Of Admin Allowed"
              v-validate="'required|numeric|max:3'"
              name="no_of_admins_allowed"
              v-model="no_of_admins_allowed"
              autocomplete="off"
            />
            <span class="text-danger text-sm">{{ errors.first('no_of_admins_allowed') }}</span>
          </div>
          <div class="vx-col md:w-1/4 form-group w-full">
            <vs-input
              class="w-full"
              label="No. Of HR Allowed"
              v-validate="'required|numeric|max:3'"
              name="no_of_hr_allowed"
              v-model="no_of_hr_allowed"
              autocomplete="off"
            />
            <span class="text-danger text-sm">{{ errors.first('no_of_hr_allowed') }}</span>
          </div>
          
          <div class="vx-col md:w-1/4 form-group w-full">
            <vs-input
              class="w-full"
              label="No. Of Vehicles Allowed"
              v-validate="'required|numeric|max:5'"
              name="no_of_vehicles_allowed"
              v-model="no_of_vehicles_allowed"
              autocomplete="off"
            />
            <span class="text-danger text-sm">{{ errors.first('no_of_vehicles_allowed') }}</span>
          </div>-->
          <div class="vx-col md:w-1/3 form-group w-full" v-show="is_freeplan">
            <vs-input
              class="w-full"
              label="Free Plan Days"
              name="freeplan_days"
              v-model="freeplan_days"
              autocomplete="off"
            />
          </div>
        </div>
        <div class="vx-row mb-2">
          <!-- <div class="vx-col md:w-1/2 mt-5 form-group w-full">
            <h5>Super Admin Features</h5>
            <ul class="centerx">
              <li class="mt-2" v-for="(feature, index) in superAdmin" :key="index">
                <vs-checkbox v-model="features_list" :vs-value="feature.id" >{{ feature.name }}</vs-checkbox>
              </li>
            </ul>
          </div>-->
          <!--     <div class="vx-col md:w-1/2  mt-5 form-group w-full">
            <h5>Admin Features</h5>
            <ul class="centerx">
              <li class="mt-2" v-for="(feature, index) in companyAdmin" :key="index">
                <vs-checkbox v-model="features_list" :vs-value="feature.id" >
                  
                  {{ feature.name }}</vs-checkbox>
              </li>
            </ul>
          </div>-->
          <!--  <div class="vx-col md:w-1/2  mt-5 form-group w-full">
            <h5>HR Manager Features</h5>
            <ul class="centerx">
              <li class="mt-2" v-for="(feature, index) in hrAdmin" :key="index">
                <vs-checkbox v-model="features_list" :vs-value="feature.id" >{{ feature.name }}</vs-checkbox>
              </li>
            </ul>
          </div>-->
          <!--   <div class="vx-col md:w-1/2  mt-5 form-group w-full">
            <h5>Users Features</h5>
            <ul class="centerx">
              <li class="mt-2" v-for="(feature, index) in user" :key="index">
                <vs-checkbox v-model="features_list" :vs-value="feature.id" >{{ feature.name }}</vs-checkbox>
              </li>
            </ul>
          </div>-->
        </div>
      </form>

      <div class="vx-row mb-2">
        <div class="vx-col w-full">
          <vs-button
            class="mt-1 m-auto"
            color="#0057FF"
            @click.prevent="addUpdatePlan()"
            :disabled="button_loading"
            id="plan-addupdate"
          >{{ planID ? 'Save' : 'Add' }}</vs-button>
          <vs-button class="mt-1 ml-4 m-auto" color="warning" @click.prevent="cancel()">Cancel</vs-button>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import { Validator } from "vee-validate";

// Vue.component('vue-image-upload', VueImageUpload);
Validator.extend("alphaNumSpace", {
  validate: value => {
    var strongRegex = new RegExp("^[a-zA-Z0-9 ]*$");
    return strongRegex.test(value);
  }
});

const dict = {
  custom: {
    plan_name: {
      required: "Please enter plan name",
      alphaNumSpace:
        "Only alphabetic characters , numeric value and space allowed",
      max: "Plan name may not be greater than 30 character"
    },
    price_per_year: {
      required: "Please enter annual price",
      decimal: "Please enter valid price (maximum 2 decimal number Allow)",
      max: "Price may not be greater than 9 digits"
    },
    price_per_month: {
      decimal: "Please enter valid price (maximum 2 decimal number Allow)",
      max: "Price may not be greater than 9 digits"
    },
    price_per_quarter: {
      decimal: "Please enter valid price (maximum 2 decimal number Allow)",
      max: "Price may not be greater than 9 digits",
      max_value: "Quarterly price can not be greater than annual price",
      is_not: "Quarterly price can not be same as annual price",
    },
    // period: {
    //   required: "Please select period",
    // },
    no_of_admins_allowed: {
      required: "Please enter no. of admin",
      numeric: "Please enter valid number",
      max: "Admin may not be greater than 3"
    },
    no_of_hr_allowed: {
      required: "Please enter no. of HR-manager",
      numeric: "Please enter valid number",
      max: "HR-manage may not be greater than 3"
    },
    no_of_vehicles_allowed: {
      required: "Please enter no. of vehicles",
      numeric: "Please enter valid number",
      max: "Vehicles may not be greater than 5"
    },
    no_of_users_allowed: {
      required: "Please enter no. of users",
      numeric: "Please enter valid number",
      max: "Users may not be greater than 5 digits"
    }
  }
};
// register custom messages
Validator.localize("en", dict);

export default {
  components: {},
  data() {
    return {
      is_sa_resident: false,
      planID: null,
      plan_name: null,
      max_users: null,
      price: null,
      period: null,
      price_per_year: null,
      price_per_month: null,
      price_per_quarter: null,
      no_of_admins_allowed: 1,
      no_of_hr_allowed: 1,
      no_of_vehicles_allowed: 1,
      no_of_users_allowed: null,
      is_freeplan: false,
      freeplan_days: null,
      features_list: [],
      superAdmin: [],
      companyAdmin: [],
      hrAdmin: [],
      user: [],
      periodList: [
        {
          text: "Quarterly",
          value: "Q"
        },
        {
          text: "Yearly",
          value: "A"
        }
      ]
    };
  },
  mounted() {
    document.getElementById("title").focus();
    this.getFeaturesList();
    if (this.$route.params.id) {
      this.getPlan(this.$route.params.id);
    }
  },
  created() {
    //   VeeValidate.Validator.extend('verify_password', {
    //   //getMessage: field => `The password must contain at least: 1 uppercase letter, 1 lowercase letter, 1 number, and 1 special character (E.g. , . _ & ? etc)`,
    //   validate: value => {
    //       var strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})");
    //       return strongRegex.test(value);
    //   }
    //  });
  },
  computed: {},
  watch: {
    superAdmin(nv) {
      if (nv && !this.planID) {
        this.getPlanSelect();
      }
    }
  },
  methods: {
    cancel() {
      history.back();
    },
    getPlanSelect() {
      let array = [];
      this.superAdmin.forEach(function(data) {
        array.push(data.id);
      });
      this.companyAdmin.forEach(function(data) {
        array.push(data.id);
      });
      this.hrAdmin.forEach(function(data) {
        array.push(data.id);
      });
      this.user.forEach(function(data) {
        array.push(data.id);
      });
      this.features_list = array;
    },
    getFeaturesList() {
      this.axios
        .get("features/getfeatures")
        .then(response => {
          let data = response.data.data;
          this.superAdmin = data.superAdmin;
          this.companyAdmin = data.companyAdmin;
          this.hrAdmin = data.hrAdmin;
          this.user = data.user;
        })
        .catch(e => {
          this.showError(e);
        });
    },
    addUpdatePlan() {
      this.$validator.validateAll().then(result => {
          this.button_loader(true, "#plan-addupdate");
          
          if (this.planID) {
            this.updatePlan();
          } else {
            this.addPlan();
          }
        
      });
    },
    addPlan() {
      let total_user = parseInt(this.no_of_users_allowed);

      let input = {
        plan_name: this.plan_name,
        features_list: this.features_list,
        no_of_admins_allowed: this.no_of_admins_allowed,
        no_of_hr_allowed: this.no_of_hr_allowed,
        no_of_vehicles_allowed: this.no_of_vehicles_allowed,
        no_of_users_allowed: this.no_of_users_allowed,
        max_users: total_user,
        price_per_year: this.price_per_year,
        // price_per_month: this.price_per_month,
        price_per_quarter: this.price_per_quarter
      };

      this.axios
        .post("subcription/create", input)
        .then(response => {
          this.button_loader(false, "#plan-addupdate");
          let text = "Subcription Plan created successfully";
          this.$vs.notify({
            text: text,
            color: "success",
            position: "top-right"
          });
          this.itemIndex = null;
          this.$router.push({ name: "adminSubcriptionPlan" });
        })
        .catch(e => {
          this.showError(e, "#plan-addupdate");
        });
    },
    getPlan(id) {
      this.$vs.loading({ color: "primary" });

      let url = "subcription/getOne?id=" + id;
      this.axios
        .get(url)
        .then(response => {
          let data = response.data.data;
          this.planID = id;
          this.plan_name = data.plan_name;
          this.price = data.price;
          this.features_list = data.features_list;
          this.period = data.period;
          this.no_of_admins_allowed = data.no_of_admins_allowed;
          this.no_of_hr_allowed = data.no_of_hr_allowed;
          this.no_of_vehicles_allowed = data.no_of_vehicles_allowed;
          this.no_of_users_allowed = data.no_of_users_allowed;
          this.price_per_year = data.price_per_year;
          this.price_per_month = data.price_per_month;
          this.price_per_quarter = data.price_per_quarter;
          this.is_freeplan = data.is_freeplan;
          this.freeplan_days = data.freeplan_days;
          this.$vs.loading.close();
        })
        .catch(e => {
          this.showError(e);
        });
    },

    updatePlan() {
      let total_user = parseInt(this.no_of_users_allowed);

      let input = {
        id: this.planID,
        plan_name: this.plan_name,
        features_list: this.features_list,
        no_of_admins_allowed: this.no_of_admins_allowed,
        no_of_hr_allowed: this.no_of_hr_allowed,
        no_of_vehicles_allowed: this.no_of_vehicles_allowed,
        no_of_users_allowed: this.no_of_users_allowed,
        max_users: total_user,
        price_per_year: this.price_per_year,
        // price_per_month: this.price_per_month,
        price_per_quarter: this.price_per_quarter
      };

      this.axios
        .put("subcription/edit", input)
        .then(response => {
          this.button_loader(false, "#plan-addupdate");
          let text = "Subcription Plan updated successfully";
          this.$vs.notify({
            text: text,
            color: "success",
            position: "top-right"
          });

          this.$router.push({ name: "adminSubcriptionPlan" });
        })
        .catch(e => {
          this.showError(e, "#plan-addupdate");
        });
    }
  }
};
</script>

<style>
table.application-detail {
  border-collapse: collapse;
  width: 100%;
}

table.application-detail th,
table.application-detail td {
  text-align: left;
  padding: 15px;
}

table.application-detail th {
  background-color: #f8f8f8;
  color: #6b6661;
  width: 25%;
}

.con-slot-label {
  word-break: break-all;
}
</style>
